import { colors } from './index'
import configureStore from '../configureStore'
import convertStyleWithMultiplier from './styleHelper'

const panelStyles = {
  elevatedContainer: {
    backgroundColor: colors.white,
    borderWidth: 0,
    elevation: 2,
  },
  cardContainer: {
    backgroundColor: colors.white,
    borderWidth: 0,
  },
  lightButton: {
    width: '100%',
    minHeight: 100,
    maxHeight: 200,
    justifyContent: 'center',
    marginTop: 12,
  },
  lightImage: {
    alignSelf: 'center',
  },
  lightsContainer: {
    alignItems: 'center',
    paddingTop: 0,
    paddingLeft: 16,
    paddingRight: 16,
    paddingBottom: 16,
  },
  cardRounding: {
    borderRadius: 6,
  },
  cardShadow: {
    elevation: 5,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowColor: colors.shark_grey,
    shadowRadius: 3,
  },
  pressablePanelContainer: {
    marginTop: 26,
  },
  pressablePanelContainerWithHint: {
    marginTop: 16,
  },
  panelText: {
    color: colors.shark_grey,
    paddingTop: 5,
    textAlign: 'center',
    fontSize: 14,
  },
}

const Sheet = () => {
  const { storedData } = configureStore.getState()
  const { fontMultiplier } = storedData
  return convertStyleWithMultiplier(fontMultiplier || 1, panelStyles)
}

export default Sheet()
